export interface LayerExtractCapabilitiesModel {
  outputFormats: string[];
}
